import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { getDashboardPath, routes } from '../routes';

export function Root() {
  const { user } = useAuth();

  return <Navigate replace to={user ? getDashboardPath(user.profile.userType) : routes.Login.path} />;
}
